import { useState } from 'react';

import {
  Modal,
  Fade,
  Backdrop,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Stack
} from '@material-ui/core';
import PropTypes from 'prop-types';
import SearchSnapshots from './SearchSnapshots';

const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    p: 4
  },
  table: {
    '&': { px: 1 },
    '.MuiDataGrid-cellContent': {
      overflow: 'auto',
      textOverflow: 'inherit'
    }
  }
};

SearchSnapshotModal.propTypes = {
  isOpen: PropTypes.bool,
  closeHandler: PropTypes.func,
  snapshots: PropTypes.array,
  setSelectedSnapshot: PropTypes.func
};

export default function SearchSnapshotModal({
  isOpen,
  closeHandler,
  snapshots,
  setSelectedSnapshot
}) {
  const [checkedSnapshot, setCheckedSnapshot] = useState(null);

  const handleSelectSnapshot = () => {
    if (checkedSnapshot) {
      setSelectedSnapshot(checkedSnapshot);
      closeHandler();
    }
  };

  return (
    <Modal
      open={isOpen}
      sx={{ outline: 'none' }}
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <Grid container sx={styles.modal}>
          <Grid item xs={12} md={1} onClick={closeHandler} />

          <Grid item xs={12} md={10}>
            <Card>
              <CardHeader title="Search Snapshots" />
              <Divider sx={{ marginTop: 2 }} />

              <CardContent>
                <SearchSnapshots
                  snapshotList={snapshots}
                  checkedSnapshot={checkedSnapshot}
                  setCheckedSnapshot={setCheckedSnapshot}
                />
              </CardContent>

              <Divider />

              <Stack direction="row" justifyContent="flex-end" p={1}>
                <Button variant="outlined" onClick={closeHandler}>
                  Close
                </Button>

                <Button
                  sx={{ ml: 1 }}
                  variant="contained"
                  disabled={!checkedSnapshot}
                  onClick={handleSelectSnapshot}
                >
                  Select Snapshot
                </Button>
              </Stack>
            </Card>
          </Grid>
          <Grid item xs={12} md={1} onClick={closeHandler} />
        </Grid>
      </Fade>
    </Modal>
  );
}
